
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 148.27 124.2"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"DocLib"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M0 .35v123.5h24.62V.35zm21 14.77H3.59V6.71H21zM28.21.35v123.5h24.63V.35zm21 14.77H31.8V6.71h17.45zM56.43.35v123.5h24.62V.35zm21 14.77H60V6.71h17.46zM81.37 8.75l43.88 115.45 23-8.75L104.38 0zm24.91 6.34L90 21.28l-3-7.86 16.31-6.2z"}})])])])
          )
        }
      }
    